export default "__VITE_ASSET__BQUiQ3IX__"